import { SexEnum } from "src/app/enums/SexEnum";
import { NHIRegIC } from "./nhiRegIc"
import { PaymentInfoDto } from "./PaymentInfoDto";
import { HistOrder } from "src/app/hist/models/hist-order";
import { NewbornNote } from "src/app/models/NewbornNote";
import { LastVitalSignItem, VitalSign } from "../hist/vital-sign";
import { RegisterConst } from "src/app/shared/constants/register-const";
import { PageData2 } from "src/app/shared/models/page-data";

export interface RegisterHistPayload {
    CC?: string;
}

export class RegisterEditDto implements IRegisterWaitListDto {
    Id: number
    RegId: number;
    IsEnabled: boolean;
    ClinicId: number;
    PatientId: number
    BookingDate: Date;
    AppointmentDate: Date;
    RegDate: Date;
    WaitNo: string;
    CheckinTime?: Date;
    BeginTime?: Date;
    EndTime?: Date;
    DiscountCode: string
    DiscountCodeDeposit: string
    DiscountCodeOwnFee: string
    DiscountCodeRegisterFee: string
    DiscountCodeSelfPay: string
    BasicDiscountCode: boolean
    BasicDiscountCodeDeposit: boolean
    BasicDiscountCodeOwnFee: boolean
    BasicDiscountCodeRegisterFee: boolean
    BasicDiscountCodeSelfPay: boolean
    ICode: string;
    ICodeName: string;
    SameTreat: string;
    DoctorCId: string;
    DoctorId: number;
    PharmacistId: number;
    IType: string;
    Nhictp: string;
    Icdt: string | Date;
    Nhiyear: string;
    Icno: string;
    RoomCode: string;
    RoomName: string;
    MedDeptCode: string;
    MedDeptName: string;
    INote: string;
    INoteName: string;
    TimeSec: number;
    VisitSourceCode: string;
    StatusCode: string;
    RegSourceCode: string;
    Tpk2m: string;
    PaymentStatusCode: string;
    Remark: string
    TimeSecName: string;
    SelfPay: number;
    IsMiddleLowIncome: boolean;
    Deposit: number;
    LAMT: number;
    OwnFee: number;
    RegisterFee: number;
    nhiConsultConvert: number;
    ReturnDate?: Date;
    IsFirstVisit: boolean;
    IsEditPatient: boolean = false;
    PatientNo: string;
    PatientFirstName: string;
    PatientMiddleName: string;
    PatientLastName: string;
    PatientBirth?: Date;
    PatientCId: string;
    PatientSexCode: SexEnum;
    PatientSexName: string;
    PatientPhoneHomeArea: string
    PatientPhoneHome: string
    PatientMobile: string
    PatientZipCode: string;
    PatientCity: string;
    PatientArea: string;
    PatientStreet: string;
    PatientNeedToCheckCName?: boolean;
    PatientRemarkOne?: string;
    PatientDiscountCode: string
    PatientDiscountCodeRegisterFee: string
    PatientLastDate: Date;
    DiscountName: string;
    StatusName: string;
    DoctorName: string;
    DoctorAccount: string;
    BeforeCharge: PaymentInfoDto;
    NHIRegICDto: NHIRegIC;
    SupArea: string;
    PaySysA: string;
    IcdtOri: string;
    Paid: number;
    CusNo: string;
    Dx: string;
    Case: string;
    Hrx: HistOrder[];
    OriHosp: string;
    OriDate: Date;
    RefDiagFee: boolean;
    UsePaperReferral: boolean;
    ReCardDate: Date;
    Kcstmr: string;
    HasHist: boolean;
    Hist?: RegisterHistPayload;
    MonCId: string;
    MonBirthdate?: Date;
    NewbornNote: NewbornNote;
    NewbornCidWarningMessage: string;
    duty: number;   //  1:櫃檯掛號掛入(報表顯示N)、2門診候診掛入(報表顯示T)
    PatientDrugAllergy?: string;
    VitalSign?: VitalSign;
    /** 各量測欄位最近一次有值的紀錄，僅供掛號畫面 tooltip 顯示，不參與存檔；null 表示不顯示提示 */
    LastVitalSign?: LastVitalSignItem[];
    RegIdOri: number;
    AOwn?: number; // 自費額
    PatientRemark?: string; // 特別記載
    // 欠卡還卡退款區
    MedOwnFee: number;

    LackCardDate: Date;
    LackTreatnum: string;
    IsRehabilitate: boolean;
    IsSupTransfer: boolean = false;  // 前端補傳紀錄用
    IsSuper: boolean = false;
    SpcIdentity: string = '';
    SoldierEdt?: Date;
    LastMCDate?: Date;
    IsPregnant?: boolean;
    IsqnoExt?: string;
    IWriteCardTime: Date;
    PharIsqno: string;
    NaturalDisasterRx: string;
    IsChangeOPDBySelf: boolean = false;
    IsOpenCloudHistLink?: boolean;
    RemarkIC: string;
    get CanBooking() {
        // 是否可報到
        var today = new Date();
        var toDate = this.getDateString(today, false, "");
        var regDate = "";
        if (this.IsAppointment && this.AppointmentDate != null) {
            regDate = this.getDateString(this.AppointmentDate, false, "");
        } else {
            regDate = this.getDateString(this.RegDate, false, "");
        }
        var nextDate = this.getDateString(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1), false, "");
        if (Number(regDate) >= Number(toDate) && Number(regDate) < Number(nextDate) &&
            this.StatusCode === RegisterConst.Code_Status_Appointment) {
            return true;
        } else {
            return false;
        }
    }
    get CanEditByDesk() {
        // 這些狀態下，掛號櫃台作業可修改該掛號資料
        var today = new Date();
        var toDate = this.getDateString(today, false, "");
        var regDate = this.getDateString(this.RegDate, false, "");
        //新增跳過日期檢查
        if ((Number(regDate) >= Number(toDate) || this.Id == 0) &&
            (this.StatusCode === RegisterConst.Code_Status_Examining ||
                this.StatusCode === RegisterConst.Code_Status_Waiting ||
                this.StatusCode === RegisterConst.Code_Status_Appointment ||
                this.StatusCode === RegisterConst.Code_Status_Emergency ||
                this.StatusCode === RegisterConst.Code_Status_ReservedLater ||
                this.StatusCode === RegisterConst.Code_Status_RegNotPay ||
                this.StatusCode === RegisterConst.Code_Status_Queue1 ||
                this.StatusCode === RegisterConst.Code_Status_Finish)) {
            return true;
        } else {
            return false;
        }
    }
    CanChargeByDesk() {
        // 這些狀態下，掛號櫃台作業可修改該掛號資料
        if (this.StatusCode === RegisterConst.Code_Status_Finish ||
            this.StatusCode === RegisterConst.Code_Status_PickUpDrug) {
            return true;
        } else {
            return false;
        }
    }
    // 可否進行看診
    get CanConsult() {
        if (this.StatusCode === RegisterConst.Code_Status_Cancel) {
            return false;
        } else {
            const today = new Date();
            const regDate = new Date(this.RegDate);
            const newRegDate = new Date(regDate.getFullYear(), regDate.getMonth(), regDate.getDate());
            const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()); // 當日的日期，去除時間部分
            if (newRegDate.getTime() > currentDate.getTime()) {
                //   if (regDate > today) {
                return false;
            } else {
                return true;
            }
        }
    }

    IsPaid(): boolean {
        if (this.PaymentStatusCode === RegisterConst.Code_Payment_Paid) {
            return true;
        } else {
            return false;
        }
    }

    IsAppointment(): boolean {
        if (this.StatusCode === RegisterConst.Code_Status_Appointment) {
            return true;
        } else {
            return false;
        }
    }
    getDeposit(total: number, otherFee: number[]): number {
        var res = 0;
        if (total > 0) {
            let allOtherFee: number = otherFee.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            res = total - allOtherFee;
        }
        return res
    }
    getDateString(ev, isRoc: boolean = false, symbol = '/', isMonth = false) {
        if (ev) {
            var d = new Date(ev);
            var month = '' + (d.getMonth() + 1);
            var day = '' + d.getDate();
            var year = isRoc ? (d.getFullYear() - 1911) : d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            if (isMonth) {
                return [year, month].join(symbol);
            } else {
                return [year, month, day].join(symbol);
            }
        }
    }
    get RemarkOne() { return this.PatientRemarkOne }
    get PatientName() { return ((this.PatientFirstName ?? '') + ' ' + (this.PatientMiddleName ?? '') + ' ' + (this.PatientLastName ?? '')).replace('  ', ' ').trim() }
}

export interface weekTime {
    label: string;
    isSelected: boolean;
}

export interface weekDay {
    name: number;
    label: string;
    allDay: boolean;
    labelS: string;
    isSelectedS: boolean;
    labelT: string;
    isSelectedT: boolean;
    labelU: string;
    isSelectedU: boolean;
}

export class RegisterCountDto {
    waitingCount: number;
    finishedCount: number;
    reserveCount: number;
    monthTotalCount: number;
}

export class SupTransferDto {
    Id: number;
    RegDate: Date;
    PatientNo: string;
    ICode: string;
    Icno: string;
    PatientCId: string;
    IType: string;
    StatusCode: string;
    SameTreat: string;
    ReCardDate: Date;
    IsSuccess?: boolean;
    Log: SupTransferLogDto[]
}

export class SupTransferLogDto {
    LogId: number;
    SendTime: Date;
    IsSuccess: boolean;
    Message: string;
}
export interface IRegisterWaitlistResult {
    list: PageData2<IRegisterWaitListDto>;
    count: RegisterCountDto
}
export interface IRegisterWaitListDto {
    Id: number;
    PatientId: number;
    StatusCode: string;
    RegDate: Date;
    TimeSec: number;
    RoomCode: string;
    BeginTime?: Date;
    DoctorName: string;
    PharmacistName?: string;
    WaitNo: string;
    Remark: string;
    RemarkName?: string;
    RemarkOne: string;
    DiscountCode: string;
    DiscountName: string;
    PatientNo: string;
    PatientName: string;
    PatientSexCode: SexEnum;
    PatientBirth?: Date;
    ICode: string;
    IType: string;
    INote: string
    SameTreat: string;
    Icno: string;
    VisitSourceCode: string;
    Tpk2m: string;
    AOwn?: number;
    LAMT?: number;
    APart?: number;
    RegisterFee?: number;
    PatientCId: string;
    Kcstmr?: string;
    PatientRemark?: string;
    ReCardDate: Date;
    IWriteCardTime: Date;
    CanBooking: boolean;
    CanEditByDesk: boolean;
    CanConsult: boolean;
    CusNo?: string;
    CusTot?: string;
}

export interface IRegPrintDialogDto {
    Id: number;
    StatusCode: string;
    IType: string;
}

export interface IRegRevertDto {
    Id: number;
    PatientNo: string;
    PatientName: string;
    PatientSexCode: string
    ICode: string;
    StatusCode: string;
    Icno: string;
    RoomCode: string;
    DoctorName: string;
    Tpk2m: string;
    WaitNo: number;
    Remark: string;
    RegDate: Date;
}
export interface IRegNextPatientDto {
    Id: number;
    DisplayName: string;
    Desc: string;
    ICode001Flag: boolean
}
